import { Type, UserSearchPayload } from "../models/User";

export enum UserActionDispatchTypes {
  GET_USERS_INVOKE = "GET_USERS_INVOKE",
  GET_USERS_SUCCESS = "GET_USERS_SUCCESS",
  GET_USERS_FAILURE = "GET_USERS_FAILURE",
  GET_USERS_RESET = "GET_USERS_RESET",
}

export enum GetRolesActionDispatchTypes {
  GET_ROLES_INVOKE = "GET_ROLES_INVOKE",
  GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS",
  GET_ROLES_RESET = "GET_ROLES_RESET",
  GET_ROLES_ERROR = "GET_ROLES_ERROR",
}

export enum HealthPlanActionDispatchTypes {
  HEALTH_PLAN_MASTER_INVOKE = "HEALTH_PLAN_MASTER_INVOKE",
  HEALTH_PLAN_MASTER_SUCCESS = "HEALTH_PLAN_MASTER_SUCCESS",
  HEALTH_PLAN_MASTER_RESET = "HEALTH_PLAN_MASTER_RESET",
  HEALTH_PLAN_MASTER_ERROR = "HEALTH_PLAN_MASTER_ERROR"
}

export enum UpdateUserStatusActionDispatchTypes {
  UPDATE_USER_STATUS_ERROR = "UPDATE_USER_STATUS_ERROR",
  UPDATE_USER_STATUS_INVOKE = "UPDATE_USER_STATUS_INVOKE",
  UPDATE_USER_STATUS_SUCCESS = "UPDATE_USER_STATUS_SUCCESS",
  UPDATE_USER_STATUS_RESET = "UPDATE_USER_STATUS_RESET",
}

export const HeaderLabel = [
  { label: "NAME", field: "UserName" },
  { label: "EMAIL ID" },
  { label: "ROLE", field: "roles" },
  { label: "HEALTH PLAN", field: "healthPlan" },
  { label: "STATUS" },
  { label: "ACTION" },
];

export const defaultFormValues: UserSearchPayload = {
  searchKeyword: "",
  roleId: null,
  healthPlanId: null,
  status: null,
  sortColumn: "UserName",
  sortOrder: "asc",
  pageNo: 1,
  pageSize: 10,
};

export const USER_STATUS_DROPDOWN_OPTION: Type[] = [
  {
    label: "Active",
    value: true,
  },
  {
    label: "Inactive",
    value: false,
  },
];

export const SESSION_TIMEOUT = 13 * 60 * 1000;
export const IDLE_TIMEOUT = 2 * 60 * 1000;